import { FC, ReactNode, useEffect, useState } from 'react';
import BPSpinner from 'components/BionicUI/loading/BPSpinner';
import BPContainer from 'components/BionicUI/container/BPContainer';
import BPButton from 'components/BionicUI/button/BPButton';
import useOnboardingProjectStore from 'stores/onboardingProjectStore';

class ReviewApplication {
  name: string;
  description: string;
  xUsername: string;
  website?: string;
  videoUrl?: string;
  telegramUsername?: string;
  whitePaper?: string;
}

const ProjectApplicationData: FC<{ handleSubmit: () => {} }> = ({
  handleSubmit,
}) => {
  const [reviewApplication, setReviewApplication] =
    useState<ReviewApplication>();
  const { projectInfo } = useOnboardingProjectStore();

  useEffect(() => {
    setReviewApplication({
      name: projectInfo?.name,
      description: projectInfo?.description,
      xUsername: projectInfo?.xUsername,
      website: projectInfo?.website,
      videoUrl: projectInfo?.projectVideoUrl,
      telegramUsername: projectInfo?.telegramUsername,
      whitePaper: projectInfo?.whitePaper?.name,
    });
  }, [projectInfo]);

  return (
    <>
      <div className="grid relative gap-5">
        <h1 className="text-[18px]">
          Here's a summary of the details you've entered.
        </h1>
        <div className="grid grid-cols-[1fr_auto] gap-y-2 justify-between text-[16px]">
          <Section>Project Details</Section>
          {/* <Item label="Email" value={reviewApplication?.email || '-'} /> */}
          <Item label="Name" value={reviewApplication?.name || '-'} />
          <Item
            label="Explainer"
            value={reviewApplication?.description || '-'}
          />
          <Item
            label="X username"
            value={`@${reviewApplication?.xUsername || '-'}`}
          />
          <Item label="Website" value={reviewApplication?.website || '-'} />
          <Item label="Video url" value={reviewApplication?.videoUrl || '-'} />
          <Item
            label="White paper"
            value={reviewApplication?.whitePaper || '-'}
          />
          <Item
            label="Telegram username"
            value={reviewApplication?.telegramUsername || '-'}
          />
        </div>
        <BPContainer twWidth="w-auto md:w-[644px] justify-normal">
          <BPButton state="primary" onClick={handleSubmit}>
            Submit
          </BPButton>
        </BPContainer>
      </div>
      {!reviewApplication && (
        <div className="grid absolute top-0 left-0 w-full h-full backdrop-blur-md bg-black place-content-center z-30">
          <BPSpinner />
        </div>
      )}
    </>
  );
};

const Section: FC<{ children: ReactNode }> = ({ children }) => (
  <div className="pt-5 col-span-2">{children}</div>
);
const Item: FC<{ label: string; value: string }> = ({ label, value }) => (
  <>
    <div className="text-bionic-muted">{label}</div>
    <div className="text-right">{value}</div>
  </>
);

export default ProjectApplicationData;
